import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Please check your .env file.');
}

if (supabaseUrl === 'https://<PROJECT-ID>.supabase.co' || supabaseAnonKey === '<ANON_KEY>') {
  throw new Error('Please update your Supabase credentials in the .env file.');
}

const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
});

// Test connection
console.log('Supabase: Connected to', supabaseUrl);

// Export as both named and default export for compatibility
export { supabase };
export default supabase;